import { render, staticRenderFns } from "./form-part-time.vue?vue&type=template&id=72d8ffb0&"
import script from "./form-part-time.vue?vue&type=script&lang=js&"
export * from "./form-part-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports